import { render, staticRenderFns } from "./EmployeeVerificationPage.vue?vue&type=template&id=d9f5a8a8&scoped=true&"
import script from "./EmployeeVerificationPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeVerificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f5a8a8",
  null
  
)

export default component.exports